// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"328":"admin","972":"research"}[chunkId] || chunkId) + "." + {"28":"f0defa3f","263":"5a5acbcc","328":"b9dfb487","581":"d284137b","972":"91ed95ed"}[chunkId] + ".chunk.js";
};